var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"btn btn-pdv btn-pdv-blue",attrs:{"disabled":_vm.busy},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.getI18n('COMMON.clean'))+" "+_vm._s(_vm.getI18nModified({ prefix: 'COMMON.filter', modifier: 2 }))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }